'use client';

/**
 * Page cliente de recherche d'éditeurs
 *
 * Utilise le composant générique EntitySearchInterface pour la recherche
 * Configuration déclarative via EDITEURS_FILTERS_CONFIG
 *
 * @module EditeursPageClient
 */

import { useTranslations } from 'next-intl';

import { EditeurCard } from '@/components/EditeurCard/EditeurCard';
import { EntitySearchInterface } from '@/components/EntitySearch/EntitySearchInterface';
import type { Meilisearch_Editeur } from '@/lib/api/meilisearch-types';
import { EDITEURS_FILTERS_CONFIG } from '@/lib/config/SearchEngine/entityFiltersConfig';
import { Env } from '@/lib/Env';

export function EditeursSearchInterface() {
  const t = useTranslations('Pages.TousLesEditeurs');

  return (
    <EntitySearchInterface<Meilisearch_Editeur>
      apiKey={Env.NEXT_PUBLIC_MEILISEARCH_KEY}
      indexName="editeurs"
      entityType="editeurs"
      searchPlaceholder={
        t('placeholder_recherche') || 'Rechercher un éditeur par nom...'
      }
      filtersConfig={EDITEURS_FILTERS_CONFIG}
      renderHitCard={(hit) => <EditeurCard editeur={hit} />}
      customNoResultsMessages={{
        titre: t('aucun_resultat') || 'Aucun éditeur trouvé',
        message:
          t('aucun_resultat_message') ||
          "Essayez d'élargir votre recherche en modifiant les filtres.",
      }}
      linkToGlobalSearchOnNoResults={false}
    />
  );
}
